module.exports = __webpack_public_path__ + "static/media/gb-zet.675f2d23.svg";